// ===== ハンバーガーメニュー =====
let hamburger = null;
let headerNav = null;

// メニューを開く処理
const openMenu = () => {
  hamburger?.classList.add('is-active');
  hamburger?.setAttribute('aria-expanded', 'true');
  headerNav?.classList.add('is-active');
};

// メニューを閉じる処理
const closeMenu = () => {
  hamburger?.classList.remove('is-active');
  hamburger?.setAttribute('aria-expanded', 'false');
  headerNav?.classList.remove('is-active');
};

// ハンバーガーメニュー初期化関数
const initHamburgerMenu = () => {
  // 要素を取得
  hamburger = document.querySelector('.l-header__hamburger');
  headerNav = document.querySelector('.l-header__nav');

  if (!hamburger || !headerNav) return;

  // 既存のイベントリスナーを削除するため、クローンで置き換え
  const newHamburger = hamburger.cloneNode(true);
  hamburger.parentNode.replaceChild(newHamburger, hamburger);
  hamburger = newHamburger;

  // ハンバーガーメニュークリックイベント
  hamburger.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();

    if (hamburger.classList.contains('is-active')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  // メニュー内のリンククリックでメニューを閉じる
  const navLinks = document.querySelectorAll('.l-header__nav-item a');
  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      closeMenu();
    });
  });

  console.log('🍔 Hamburger menu initialized');
};

// メニュー外クリックで閉じる（グローバルイベントは1回だけ登録）
let outsideClickHandlerAttached = false;
if (!outsideClickHandlerAttached) {
  document.addEventListener('click', e => {
    if (
      headerNav?.classList.contains('is-active') &&
      !hamburger?.contains(e.target) &&
      !headerNav?.contains(e.target)
    ) {
      closeMenu();
    }
  });
  outsideClickHandlerAttached = true;
}

export { closeMenu, initHamburgerMenu, openMenu };
